import DependenciesDataTableHandler from "@Modules/batchesProcessing/containers/dataTableHandlers/dailyProcessing/dependencies/DependenciesDataTableHandler"

const DependenciesPage = () => {
  return (
    <>
      <DependenciesDataTableHandler />
    </>
  )
}

export default DependenciesPage